module.exports = __webpack_public_path__ + "img/checklist-button-body.28540c31.png";